import { entityBoardFor } from "../lib/heroBoards";

/* Dedicated AI-illustrated hero board on airport/airline profiles —
   themed by entity type with a subtle caption strip naming the theme. */
export const EntityHeroBoard = ({ kind = "airport", country, name, type }) => {
  if (!country && !name) return null;
  const { src, label } = entityBoardFor(kind, { country, name, type });
  return (
    <div className="max-w-7xl mx-auto sm:px-5 pt-2" data-testid="entity-hero-board">
      <div className="relative">
        <img src={src} alt={`${name || country} ${label} illustration`}
          className="w-full h-16 sm:h-28 object-cover sm:rounded-lg" data-testid="entity-hero-board-img" />
        <span data-testid="entity-hero-board-caption"
          className="absolute bottom-1.5 right-2 sm:bottom-2 sm:right-3 text-[9px] sm:text-[10px] font-800 uppercase tracking-wide text-white/95 bg-black/40 backdrop-blur-sm rounded-full px-2 py-0.5 sm:px-2.5">
          {label}
        </span>
      </div>
    </div>
  );
};
